import { Tooltip } from "react-tooltip";

export default function ValidationErrorsTooltip({
  tooltipId,
  errorMessages,
  showTooltip,
}: {
  tooltipId: string;
  errorMessages: string[];
  showTooltip: boolean;
}) {
  if (!showTooltip) return null;

  return (
    <Tooltip id={tooltipId}>
      <div className="text-red-200 flex gap-2 text-xs">
        <div className="">error:</div>
        <div className="flex flex-col">
          {errorMessages.map((m, i) => (
            <div key={i}>{m}</div>
          ))}
        </div>
      </div>
    </Tooltip>
  );
}
